import React from 'react';
import PropTypes from 'prop-types';
import CTAVideoSeriesStyles from './CTAVideoSeries.styled';
import LinkVideo from '../Shared/LinkVideo';
import { useInView } from 'react-intersection-observer';
//TODO: Remove happy houses
//import HomeTipsIcon from '../Shared/Icons/HomeTipsIcon';

const CTAVideoSeries = ({ title = '', link = {}, isAnimated = true }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });

  return (
    <CTAVideoSeriesStyles
      ref={ref}
      className={`block-cta_video_series ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
    >
      <div className='inner'>
        {/* <HomeTipsIcon /> */}
        <h2 className='type-h4'>{title}</h2>
        <LinkVideo {...link}>Watch Series</LinkVideo>
      </div>
    </CTAVideoSeriesStyles>
  );
};

CTAVideoSeries.propTypes = {
  title: PropTypes.string.isRequired,
  link: PropTypes.shape({
    to: PropTypes.string,
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isAnimated: PropTypes.bool,
};

export default CTAVideoSeries;
